const API_VER_V1 = 'v1.0'
const API_VER = 'v2.0'
export const SubscriptionEndpoints = {
  PAYMENT_STATUS_URI: `/subscription/api/${API_VER}/subscription/get_subscription_status/`,
  PAYMENT_STATUS_URI_V1: `/subscription/api/${API_VER_V1}/subscription/get_subscription_status/`,
}
